var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDirectMailGoalPlanning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: 244.256,
    viewBox: "0 0 331.287 244.256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3125",
    "data-name": "Group 3125",
    transform: "translate(-548.838 -2396.744)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1506",
    "data-name": "Rectangle 1506",
    transform: "translate(549 2416)",
    fill: "#fff",
    stroke: "#e6e7e8",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 70,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 158,
    height: 68,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1557",
    "data-name": "Rectangle 1557",
    width: 160,
    height: 70,
    transform: "translate(720 2416)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1505",
    "data-name": "Rectangle 1505",
    width: 74.799,
    height: 22.41,
    transform: "translate(549 2521)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("text", {
    id: "Mailer_to_Call",
    "data-name": "Mailer to Call",
    transform: "translate(671.743 2557)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -29.165,
    y: 0
  }, "Mailer to Call")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1554",
    "data-name": "Rectangle 1554",
    width: 74.799,
    height: 22.41,
    transform: "translate(634.201 2521)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("text", {
    id: "Mailer_to_Call-2",
    "data-name": "Mailer to Call",
    transform: "translate(757.743 2638)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -29.165,
    y: 0
  }, "Mailer to Call")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1555",
    "data-name": "Rectangle 1555",
    width: 74.799,
    height: 22.41,
    transform: "translate(719.201 2521)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("text", {
    id: "_.31_",
    "data-name": ".31%",
    transform: "translate(671.743 2537)",
    fill: "#7f7f7f",
    fontSize: 14,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -14.831,
    y: 0
  }, ".31%")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1556",
    "data-name": "Rectangle 1556",
    width: 74.799,
    height: 22.41,
    transform: "translate(804.5 2521)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("text", {
    id: "_.03_",
    "data-name": ".03%",
    transform: "translate(757.743 2617)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.712,
    y: 0
  }, ".03%")), /*#__PURE__*/React.createElement("text", {
    id: "Mailers_Mo.",
    "data-name": "Mailers/Mo.",
    transform: "translate(585.743 2557)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -27.024,
    y: 0
  }, "Mailers/Mo.")), /*#__PURE__*/React.createElement("text", {
    id: "_3_800",
    "data-name": "3,800",
    transform: "translate(585.743 2537)",
    fill: "#7f7f7f",
    fontSize: 14,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -17.097,
    y: 0
  }, "3,800")), /*#__PURE__*/React.createElement("text", {
    id: "_8",
    "data-name": 8,
    transform: "translate(629 2461)",
    fill: "#b94f4f",
    fontSize: 27,
    fontFamily: "Montserrat-Regular, Montserrat"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.613,
    y: 0
  }, "8")), /*#__PURE__*/React.createElement("text", {
    id: "_4_250",
    "data-name": "4,250",
    transform: "translate(800 2461)",
    fill: "#107889",
    fontSize: 27,
    fontFamily: "Montserrat-Regular, Montserrat"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -36.437,
    y: 0
  }, "4,250")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1559",
    "data-name": "Rectangle 1559",
    width: 74.799,
    height: 22.41,
    transform: "translate(720.201 2602)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1560",
    "data-name": "Rectangle 1560",
    width: 74.799,
    height: 22.41,
    transform: "translate(805.201 2602)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("text", {
    id: "New_Patients",
    "data-name": "New Patients",
    transform: "translate(842 2557)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -29.521,
    y: 0
  }, "New Patients")), /*#__PURE__*/React.createElement("text", {
    id: "_6.5",
    "data-name": 6.5,
    transform: "translate(842 2537)",
    fill: "#7f7f7f",
    fontSize: 14,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9.704,
    y: 0
  }, "6.5")), /*#__PURE__*/React.createElement("text", {
    id: "Call_Conv.",
    "data-name": "Call Conv.",
    transform: "translate(758.795 2557)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21.98,
    y: 0
  }, "Call Conv.")), /*#__PURE__*/React.createElement("text", {
    id: "Call_Conv.-2",
    "data-name": "Call Conv.",
    transform: "translate(844.795 2638)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21.98,
    y: 0
  }, "Call Conv.")), /*#__PURE__*/React.createElement("text", {
    id: "_42_",
    "data-name": "42%",
    transform: "translate(758.795 2537)",
    fill: "#7f7f7f",
    fontSize: 14,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -12.988,
    y: 0
  }, "42%")), /*#__PURE__*/React.createElement("text", {
    id: "_42_2",
    "data-name": "42%",
    transform: "translate(844.795 2617)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.133,
    y: 0
  }, "42%")), /*#__PURE__*/React.createElement("text", {
    id: "Based_on_a_cumulative_of_your_monthly_averages:",
    "data-name": "Based on a cumulative of your monthly averages:",
    transform: "translate(548.838 2510.35)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Based on a cumulative of "), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, "your monthly averages:")), /*#__PURE__*/React.createElement("text", {
    id: "National_Averages:",
    "data-name": "National Averages:",
    transform: "translate(719.838 2591.35)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "National Averages:")), /*#__PURE__*/React.createElement("text", {
    id: "New_Patient_Goal",
    "data-name": "New Patient Goal",
    transform: "translate(549 2409.744)",
    fill: "#b94f4f",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "New Patient Goal")), /*#__PURE__*/React.createElement("text", {
    id: "Monthly_mailers_needed",
    "data-name": "Monthly mailers needed",
    transform: "translate(720 2409.744)",
    fill: "#329998",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Monthly mailers needed")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1748",
    "data-name": "Rectangle 1748",
    width: 111.799,
    height: 34.41,
    transform: "translate(550 2602)",
    fill: "none",
    stroke: "#e6e7e8",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "_1_860",
    "data-name": "$1,860",
    transform: "translate(605.743 2625)",
    fill: "#107889",
    fontSize: 16,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -24.031,
    y: 0
  }, "$1,860")), /*#__PURE__*/React.createElement("text", {
    id: "Budget_per_mailing",
    "data-name": "Budget per mailing",
    transform: "translate(605.838 2591.35)",
    fill: "#107889",
    fontSize: 10,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -41.704,
    y: 0
  }, "Budget per mailing")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectMailGoalPlanning);
export default __webpack_public_path__ + "static/media/directMailGoalPlanning.c24a8130.svg";
export { ForwardRef as ReactComponent };